module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0030.7f04889d.jpg";